
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsa788a3c1355a66a0581ba5bb8e152bd2en from './en.yaml'
            i18n.addResourceBundle('en', 'a788a3c1355a66a0581ba5bb8e152bd2', flattenObject(nsa788a3c1355a66a0581ba5bb8e152bd2en), true, true);
        
        export default 'a788a3c1355a66a0581ba5bb8e152bd2';
    